import React, { Component } from 'react';
import { coloresEmma, consulta, obtenerValoresFiltros, formulario, mostrarError } from "../../global/js/funciones";
import { Typography, Dialog, DialogContent, Button, Box, Divider, Checkbox, Toolbar, AppBar, IconButton, Icon } from '@material-ui/core'
import TareasTerminadas from "../general/TareasTerminadas";
import emma_w from '../../global/imagenes/emma_w.png';
import cuidamos from '../../global/imagenes/cuidamos.png';
import emma from "../../global/imagenes/emma_zoom.png";
import AppBarModal from '../general/AppBarModal';
import { actualizarMensaje } from "../../redux/actions/actGlobal";
import { connect } from 'react-redux'


class Politica extends Component {
    constructor(props) {
        super(props)
        this.state = {
            validacion_politica: { 'valido': false, 'obligatorio:': false },
            cargar_politica: true,
            inicio_politica: true,
            politica: [],

            check_politica: false,
            linkPolitica: ''
        }
    }

    componentDidMount() {
        this.validar_politicas();
    }

    async componentDidUpdate({ }, { inicio_politica }) {
        let { inicio_politica: inicio_politicaNew } = this.state;
        if (inicio_politica !== inicio_politicaNew && !inicio_politicaNew) {
            this.setState({ cargar_politica: true })
            let politicaOrdenada = await obtenerValoresFiltros([{ 'llave': 'generica', 'valor': 40 }, { 'llave': 'estado', 'valor': 1 }])
            politicaOrdenada = politicaOrdenada.sort((a, b) => a.valorb - b.valorb);
            this.setState({ politica: politicaOrdenada, cargar_politica: false })
        }
    }

    validar_politicas = () => {
        consulta('api/v1.0/personas/validar_politica', null, null, (error, estado, resp) => {
            console.log(resp)
            this.setState({ validacion_politica: { 'valido': !resp.valido, 'obligatorio': resp.obligatorio } })
        });
    }

    onsubmit = () => {
        let { check_politica } = this.state
        let { actualizarMensaje } = this.props

        if (!check_politica) {
            actualizarMensaje({ titulo: 'Acepte la politica para continuar.', tipo: 'info', mostrar: true, tiempo: 6000 });
            return null
        }



        this.setState({ cargar_politica: true })
        formulario(`api/v1.0/personas/aceptar_politica`, null, "post", (error, estado, resp) => {
            let titulo = 'Ha ocurrido un error, contacte con el administrador.', tipo = 'error';
            if (!error) {
                if (estado === 201) {
                    tipo = 'success';
                    titulo = resp.titulo;
                    this.setState({ validacion_politica: { 'valido': false, 'obligatorio:': false } })

                } else {
                    tipo = 'info';
                    titulo = resp.titulo ? resp.titulo : mostrarError(resp);
                }
            }
            actualizarMensaje({ titulo, tipo, mostrar: true, tiempo: 6000 });
            this.setState({ cargar_politica: false })
        })
    }

    render() {
        let { validacion_politica, inicio_politica, politica, cargar_politica, check_politica } = this.state
        let linkPolitica = ''
        const textosPolitica = politica.map((text, index) => {
            if (text.valora === 'DOCUMENTO') {
                linkPolitica = text.archivo;
                return null;
            }

            if (text.valora === 'TEXTO') {
                return (
                    <div key={index} style={{ marginBottom: 10, marginTop: 5 }}>
                        <span style={{ fontWeight: 'bold', color: coloresEmma.primarycolor }}>
                            {text.nombre}:&nbsp;
                        </span>
                        <span>{text.descripcion}</span>
                    </div>
                );
            }

            if (text.valora === 'LISTA') {
                return (
                    <div key={index} style={{ marginBottom: 10, marginTop: 5 }}>
                        <div
                            style={{
                                fontWeight: 'bold',
                                fontSize: 14,
                                color: coloresEmma.primarycolor,
                                marginBottom: 6,
                            }}
                        >
                            {text.nombre}
                        </div>

                        {text.descripcion
                            .split(';')
                            .filter(e => e.trim() !== '')
                            .map((texto, i) => (
                                <div
                                    key={i}
                                    style={{
                                        display: 'flex',
                                        alignItems: 'flex-start',
                                        marginBottom: 6,
                                        paddingLeft: 12,
                                    }}
                                >
                                    {/* Punto */}
                                    <div
                                        style={{
                                            width: 5,
                                            height: 5,
                                            borderRadius: '50%',
                                            backgroundColor: 'black',
                                            marginTop: 7,
                                            marginRight: 10,
                                        }}
                                    />

                                    <div style={{ fontSize: 14 }}>
                                        {texto.trim()}
                                    </div>
                                </div>
                            ))}
                    </div>
                );
            }

            return null;
        });


        return (<Dialog
            fullWidth
            maxWidth={inicio_politica ? "sm" : "lg"}
            open={validacion_politica.valido}
            onClose={(event, reason) => {
                if (validacion_politica.obligatorio && (reason === 'backdropClick' || reason === 'escapeKeyDown')) {
                    return;
                }
                this.setState({ validacion_politica: { 'valido': false, 'obligatorio': validacion_politica.obligatorio } })
            }}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
        >
            <AppBar style={{
                position: 'relative',
                backgroundColor: coloresEmma.secondarycolor,
            }} elevation={2}>
                <Toolbar>
                    {!validacion_politica.obligatorio && <IconButton edge="start" color="inherit" onClick={() => this.setState({ validacion_politica: { 'valido': false, 'obligatorio': validacion_politica.obligatorio } })} aria-label="close">
                        <Icon>close</Icon>
                    </IconButton>
                    }
                </Toolbar>
            </AppBar>

            <DialogContent style={{ padding: "20px 60px" }} className="scroll">
                {inicio_politica ?
                    <>

                        <Box sx={{ textAlign: 'center' }}>
                            <img src={emma} style={{ width: '120px', maxWidth: '170px', minWidth: '70px', height: "120px" }} alt='Imagen Tipo' />

                        </Box>

                        <Typography
                            variant="h5"
                            component="h5"
                            align="center"
                            style={{ marginBottom: "20px", fontWeight: "500" }}
                            gutterBottom
                        >
                            ¡Acepta la Política de Tratamiento de Datos Personales!
                        </Typography>
                        <Typography
                            variant="body1"
                            component="p"
                            style={{ padding: "0 20px" }}
                        >
                            Para seguir usando los servicios de EMMA sin problemas, necesitamos que aceptes nuestra política de tratamiento de datos personales.
                        </Typography>

                        <Box sx={{ textAlign: 'center' }}>
                            <Button
                                variant="text"
                                className="btn-politica"
                                onClick={() => this.setState({ inicio_politica: false })}
                            >
                                Revisar
                            </Button>
                        </Box></>
                    :
                    !cargar_politica ? <>
                        <Box sx={{ textAlign: 'center' }}>
                            <img src={cuidamos} style={{ width: '300px', maxWidth: '300px', minWidth: '120px' }} alt='Imagen Tipo' />

                        </Box>
                        <Typography
                            variant="h6"
                            component="h6"
                            align="center"
                            style={{ marginBottom: "20px", fontWeight: "700" }}
                            gutterBottom
                        >
                            Política de Tratamiento de Datos Personales
                        </Typography>
                        <Divider style={{ height: 2, backgroundColor: '#ccc', marginBottom: '30px' }} />
                        <div>
                            {textosPolitica}

                            <Box style={{ marginBottom: 20, marginTop: 30 }}>
                                <Box
                                    style={{
                                        display: 'flex',
                                        alignItems: 'flex-start',
                                    }}
                                >
                                    <Checkbox
                                        checked={check_politica}
                                        onChange={(e) =>
                                            this.setState({ check_politica: e.target.checked })
                                        }
                                        size="small"
                                        style={{
                                            padding: 0,
                                            marginTop: 2,
                                            color: coloresEmma.secondarycolor,
                                        }}
                                        inputProps={{ 'aria-label': 'Aceptar política' }}
                                    />

                                    <Box style={{ marginLeft: 8 }}>
                                        <Typography
                                            variant="body2"
                                            component="span"
                                            style={{ lineHeight: '18px' }}
                                        >
                                            He leído y acepto{' '}
                                        </Typography>

                                        <Typography
                                            variant="body2"
                                            component="span"
                                            style={{
                                                fontWeight: 600,
                                                color: coloresEmma.primarycolor,
                                                textDecoration: 'underline',
                                                cursor: 'pointer',
                                                lineHeight: '18px',
                                            }}
                                            onClick={() => window.open(linkPolitica, '_blank')}
                                        >
                                            la política de tratamiento de datos personales de la Universidad de la Costa
                                        </Typography>
                                    </Box>
                                </Box>
                            </Box>


                            <Box sx={{ textAlign: 'center' }}>
                                <Button
                                    variant="text"
                                    size="large"
                                    style={{
                                        'color': '#fff',
                                        'background': '#B70E0C',
                                        'margin': '10px 0',
                                        'padding': '10px 50px'
                                    }}
                                    onClick={() => this.onsubmit()}
                                >
                                    Confirmar
                                </Button>
                            </Box>
                        </div>
                    </> :

                        <Box sx={{ textAlign: 'center', paddingBottom: '30px' }}>
                            <TareasTerminadas mensaje="Cargando ..." marginTop="7%" imagen={emma_w} widthImg="7%" cargando={true} />
                        </Box>

                }
            </DialogContent>
        </Dialog>)
    }
}

const mapStateToProps = (state) => {
    return {}
}

const mapDispatchToProps = {
    actualizarMensaje
}

export default connect(mapStateToProps, mapDispatchToProps)(Politica);